import React, { useEffect, useMemo } from 'react';
import TopicLayerSettingsCommands from '../mapContent/topics/TopicLayerSettingsCommands';

export interface LegendItemProps {
  contentType?: string | undefined;
  imageData?: string | undefined;
  image: Blob | undefined;
  label: string;
  showCommands?: boolean;
  metadataUrl?: string | undefined;
  downloadUrl?: string | undefined;
}

const LegendItem = ({
  contentType,
  imageData,
  image,
  label,
  showCommands,
  metadataUrl,
  downloadUrl,
}: LegendItemProps) => {
  const imgSrc = useMemo(() => {
    return image ? URL.createObjectURL(image) : `data:${contentType};base64,${imageData}`;
  }, [image, contentType, imageData]);

  useEffect(() => {
    return () => {
      if (image) {
        URL.revokeObjectURL(imgSrc);
      }
    };
  }, [image, imgSrc]);

  return (
    <div className="legend__row">
      <figure className="legend-list__item-figure">
        <img src={imgSrc} className="legend-list__item-figure--image" alt={label} />
        {label && (
          <figcaption className="legend-list__item-figure--caption" title={label}>
            {label}
          </figcaption>
        )}
      </figure>
      {showCommands && (
        <TopicLayerSettingsCommands metadataUrl={metadataUrl} downloadUrl={downloadUrl} />
      )}
    </div>
  );
};

export default LegendItem;
